module.exports = __webpack_public_path__ + "static/media/Nichwagh-Ridge-Master-Deed.db6f1f13.pdf";